var map = {
	"./Inter-Black.woff": 15179,
	"./Inter-BlackItalic.woff": 25479,
	"./Inter-Bold.woff": 36419,
	"./Inter-BoldItalic.woff": 87919,
	"./Inter-ExtraBold.woff": 36637,
	"./Inter-ExtraBoldItalic.woff": 50853,
	"./Inter-ExtraLight.woff": 52230,
	"./Inter-ExtraLightItalic.woff": 63858,
	"./Inter-Italic.woff": 19048,
	"./Inter-Light.woff": 21316,
	"./Inter-LightItalic.woff": 6612,
	"./Inter-Medium.woff": 91143,
	"./Inter-MediumItalic.woff": 50179,
	"./Inter-Regular.woff": 47796,
	"./Inter-SemiBold.woff": 23493,
	"./Inter-SemiBoldItalic.woff": 70717,
	"./Inter-Thin.woff": 77403,
	"./Inter-ThinItalic.woff": 17047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48041;